<template>
  <div class="public-content attr-management">
    <div class="region-title" style="background: #fff">属性管理</div>
    <div class="add-category">
      <el-button round type="primary" @click="$router.push('/AttrTaskNo')">属性值映射任务号</el-button>
      <el-button round type="primary" @click="$router.push('/attrcolor')">属性值色块管理</el-button>
      <el-button round type="primary" v-permission="'pms:admin:dict:add'" @click="changeList('添加属性名')">添加</el-button>
    </div>
    <div class="data-list">
      <el-table :data="tableData" style="width: 100%;margin-bottom: 20px;" row-key="id" border :tree-props="{children: 'children'}"
        :row-class-name="rowClassName">
        <el-table-column width="200px" prop="id" label="编号"></el-table-column>
        <el-table-column min-width="200px" prop="propKey" label="属性名"></el-table-column>
        <el-table-column min-width="200px" prop="propVal" label="属性值"> </el-table-column>
        <el-table-column min-width="200px" label="操作">
          <template v-slot="scope">
            <span class="color-blue" v-permission="'pms:admin:dict:update'" @click="changeList('编辑', scope.row)">编辑<br></span>
            <span class="color-blue" v-if="scope.row.top && $hasPermission('pms:admin:dict:add')" @click="changeList('添加', scope.row)">添加<br></span>
            <span class="color-blue" v-permission="'pms:admin:dict:delete'" @click="changeList('删除', scope.row)">删除<br></span>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <CombinedDialog ref="dialogRef" @delete="deleteAttr1"></CombinedDialog>
    <!--    分页-->
    <v-pagination class="v-pagination" :queryInfo="queryInfo" v-if="queryInfo.total !== ''" @changePage="changePage"></v-pagination>
    <!-- 删除确认 -->
    <el-dialog :close-on-click-modal="false" title="提示" :visible.sync="deleteDialog" width="30%">
      <span>确认删除该属性吗？</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="deleteDialog = false">取 消</el-button>
        <el-button type="primary" @click="deleteAttr">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>
 <script>
import CombinedDialog from '@/components/Dialog/CombinedDialog/index'
import VPagination from '@/components/Pagination/index'
import { dictList, dictQueryByPid, dictShow, dictDelete } from '@/api/pms'
export default {
  name: 'attr-management',
  components: {
    CombinedDialog,
    VPagination
  },
  data () {
    return {
      deleteId: '',
      deleteDialog: false,
      tableData: [],
      queryInfo: {
        type: 3,
        pageNum: 1, // 当前显示第几页
        pageSize: 10, // 每一页显示条数
        total: 0
      }
    }
  },
  created () {
    this.getAttr(this.queryInfo)
  },
  methods: {
    // 删除
    deleteAttr () {
      dictDelete(this.deleteId).then(res => {
        if (res.data.success) {
          this.$message.success('删除成功')
          this.getAttr(this.queryInfo)
          this.deleteDialog = false
        }
      })
    },
    rowClassName ({ row, rowIndex }) {
      // 把每一行的索引放进row
      row.index = rowIndex
    },
    getAttr (val) {
      let _this = this
      dictList({ pageNum: val.pageNum, pageSize: val.pageSize }).then((res) => {
        if (res.data.success) {
          if (res.data.data.records.length === 0 && res.data.data.total !== 0 && this.queryInfo.pageNum !== 1) {
            this.queryInfo.pageNum--
            this.getAttr(this.queryInfo)
          }
          let newList = res.data.data.records
          this.queryInfo.total = res.data.data.total
          newList.forEach((item) => {
            item.parentId = 0
            item.children = []
            item.top = true
            item.operation = {
              edit: '编辑',
              add: '添加',
              delete: '删除'
            }
            _this.getAttrValue(item)
          })
          this.tableData = newList
        } else {
        }
      })
    },
    getAttrValue (item) {
      dictQueryByPid(item.id).then((res) => {
        if (res.data.success) {
          item.children = res.data.data
          item.children.forEach((item2) => {
            item2.parentId = item.id
            item2.isMallShow = -1
            item2.propKey = ''
            item2.operation = {
              edit: '编辑',
              delete: '删除'
            }
          })
        } else {
        }
      })
    },
    changeList (val, content) {
      if (val === '删除') {
        this.deleteDialog = true
        this.deleteId = content.id
      }
      if (val === '编辑' && content.propKey !== '') {
        this.$router.push({
          path: '/addattrname',
          query: {
            id: content.id,
            parentId: content.parentId
          }
        })
      }
      if (val === '添加属性名') {
        this.$router.push({
          path: './addattrname',
          query: {
            id: -1,
            parentId: 0
          }
        })
      }
      if (val === '编辑' && content.propKey === '') {
        this.$router.push({
          path: './addattrvalue',
          query: {
            id: content.id,
            parentId: content.parentId,
            type: 0
          }
        })
      }
      if (val === '添加') {
        this.$router.push({
          path: './addattrvalue',
          query: {
            id: content.id,
            parentId: content.id,
            type: 1
          }
        })
      }
    },
    primaryAdd () {
      this.$refs.dialogRef.show('addCategory', '添加属性名', '', '', '', '属性名')
    },
    changePage (val) {
      this.queryInfo = val
      this.getAttr(this.queryInfo)
    },
    // 前端是否显示
    changeMall (id, show) {
      dictShow({ dictId: id, isShow: show }).then((res) => {
        if (res.data.success) {
        } else {
        }
      })
    },
    //  删除属性
    deleteAttr1 () {
      this.getAttr(this.queryInfo)
    }
  }
}
</script>
 <style scoped lang="less">
@import "./styles";
@deep: ~">>>";
</style>
